export default __webpack_public_path__ + "static/mark-crampton-smith-d-d35af2273228543f30a62cec6b1bc2ae.png";